(function ($) {
  Drupal.behaviors.oculus_mod4_quiz = {
    attach: function (context) {
      $('#oculus_mod4', context).once('oculus_mod4_quiz', function () {
        // Init the controller.
        var controller = new ScrollMagic.Controller();
        // Set the parallax duration
        var windowHeight = $(window).height();
        var parallaxDuration = windowHeight / 1.1;
        // Set the scene/
        var oculus_mod4_scene1 = new ScrollMagic.Scene({
          triggerElement: '#oculus_mod4',
          offset: -150,
          duration: parallaxDuration
        })
          .setTween('.oculus_mod4_video_parallax', 8, {
            top: '-45%',
            ease: Linear.easeNone
          })
          .addTo(controller);

        if (!$('#oculus_mod4_video').data('yt1-src')) {
          $('#oculus_mod4 .oculus_mod4_video_cta').hide();
        }

        $('.oculus_quiz_copy_btn').on('click', function () {
          $('#oculus_mod41').slideDown();
          $('html, body').animate(
            {
              scrollTop: $('#oculus_mod41').offset().top - 150
            },
            1500,
            'easeInOutQuad'
          );
        });
        if ($('#oculus_mod4').data('scrollmagic') === 1) {
          // Hide the container initially.
          $('#oculus_mod4').css({
            opacity: '0',
            'padding-top': '5%'
          });
        }
        if (window.location.href.indexOf('mod4_quiz') > -1) {
          $('html, body').animate(
            {
              scrollTop: $('#oculus_mod41').offset().top - 85
            },
            1550,
            'easeInOutQuad'
          );
          $('.oculus_quiz_copy_btn').trigger('click');
        } else if (
          window.location.href.indexOf('mod4') > -1 &&
          window.location.href.indexOf('mod4_quiz') === -1
        ) {
          $('html, body')
            .delay(1670)
            .animate(
              {
                scrollTop: $('#oculus_mod4').offset().top - 85
              },
              1500,
              'easeInOutQuad'
            );
        }

        $(window).on('load', function () {
          // Fade in the module on the page, if requested.
          if ($('#oculus_mod4').data('scrollmagic') === 1) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            // Init scrollMagic Controller Class
            var controller = new ScrollMagic.Controller();
            // Handle single play-through
            var offset;

            if ($('#oculus_mod4').data('offset')) {
              offset = $('#oculus_mod4').data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            var triggerFadeScene = new ScrollMagic.Scene({
              triggerElement: '#oculus_mod4',
              offset: offset
            }).on('start', function () {
              triggerFade();
            });

            controller.addScene([triggerFadeScene]);
          }
        });
        var hasFaded = false;

        // Animation
        function triggerFade() {
          if (hasFaded === false) {
            hasFaded = true;
            $('#oculus_mod4').animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }
      });
    }
  };
})(jQuery);
